import { AbstractControl, ValidationErrors } from '@angular/forms';
import { PortalFieldConfig } from '@portal/form/data-access';

export function requiredTrueValidator(control: AbstractControl, field: PortalFieldConfig): ValidationErrors | null {
  if (field.props?.requiredTrue !== true) return null;

  if (control?.value === true) return null;

  return { requiredTrue: true };
}

const atLeastOneSelected = (val: unknown) => {
  if (val == null) return false;
  if (Array.isArray(val)) return val.length > 0;
  if (val instanceof Set || val instanceof Map) return val.size > 0;
  if (typeof val === 'object')
    return Object.values(val).some(v => v === true || (typeof v === 'string' && v.length > 0) || (Array.isArray(v) && v.length > 0));
  if (typeof val === 'string') return val.trim().length > 0;
  if (typeof val === 'boolean') return val === true;
  if (typeof val === 'number') return val !== 0;
  return Boolean(val);
};

export function requiredSelectedValidator(control: AbstractControl, field: PortalFieldConfig): ValidationErrors | null {
  const val = control?.value;

  if (field.props?.required !== true || atLeastOneSelected(val)) return null;

  return { requiredSelected: true };
}
